import React, { useState } from 'react';
import { copyHomeworkImage } from '../utils/diaryUtils';

const HomeworkImageViewer = ({ imageUrl, title = "Homework Image", onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleCopyImage = async () => {
    setLoading(true);
    try {
      await copyHomeworkImage(imageUrl);
    } catch (error) {
      console.error('Copy failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `homework_${Date.now()}.png`;
    link.click();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0,0,0,0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '20px',
        maxWidth: '90%',
        maxHeight: '90%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '15px',
          paddingBottom: '10px',
          borderBottom: '2px solid #e2e8f0'
        }}>
          <h3 style={{ margin: 0, color: '#1e40af', fontSize: '18px' }}>📚 {title}</h3>
          <button
            onClick={onClose}
            style={{
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            ✕
          </button>
        </div>

        {/* Image */}
        <div style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '15px'
        }}>
          <img
            src={imageUrl}
            alt={title}
            style={{
              maxWidth: '100%',
              maxHeight: '60vh',
              objectFit: 'contain',
              border: '2px solid #e2e8f0',
              borderRadius: '8px'
            }}
          />
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleCopyImage}
            disabled={loading}
            style={{
              background: loading ? '#9ca3af' : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            {loading ? '⏳' : '📋'} {loading ? 'Copying...' : 'Copy to Clipboard'}
          </button>
          
          <button
            onClick={handleDownload}
            style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            💾 Download
          </button>
          
          <button
            onClick={onClose}
            style={{
              background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            ⬅️ Back
          </button>
        </div>

        {/* Instructions */}
        <div style={{
          marginTop: '15px',
          padding: '10px',
          background: '#f0f9ff',
          borderRadius: '6px',
          fontSize: '14px',
          color: '#0369a1',
          textAlign: 'center'
        }}>
          💡 <strong>Tip:</strong> After copying, you can paste the image directly into WhatsApp, email, or any other app! Use the Back button to return to the diary.
        </div>
      </div>
    </div>
  );
};

export default HomeworkImageViewer;